import { ButtonHTMLAttributes, FC } from 'react'
import { ChevronDownIconWhite } from '@/root/ui/shared/icons/ChevronDownIconWhite'
import cn from 'classnames'

interface ToggleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isOpen: boolean
  label: string
}

export const ToggleButton: FC<ToggleButtonProps> = ({ isOpen, label, ...props }) => {
  return (
    <button type="button" className="group flex items-center gap-2.5 pt-0.5" {...props}>
      <span className="text-neutral-darker text-xs">{label}</span>
      <ChevronDownIconWhite
        width={14}
        height={8}
        color="black"
        className={cn(
          'transition-transform duration-150 ease-out group-active:scale-y-50',
          isOpen ? '-scale-y-100' : 'scale-y-100'
        )}
      />
    </button>
  )
}
